import { render, staticRenderFns } from "./FrequenciaMensal.2.vue?vue&type=template&id=42e33fe5&scoped=true&"
import script from "./FrequenciaMensal.2.vue?vue&type=script&lang=js&"
export * from "./FrequenciaMensal.2.vue?vue&type=script&lang=js&"
import style0 from "./FrequenciaMensal.2.vue?vue&type=style&index=0&id=42e33fe5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e33fe5",
  null
  
)

export default component.exports